export default "__VITE_ASSET__6352c210__"